module.exports = __webpack_public_path__ + "static/media/insButtonPrice.0cacc63c.jpg";